<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box">
          <div class="box-body">
            <v-server-table url="" :columns="columns" :options="options" name="keywords" ref="macrotags"
                            @loading="toggleLoading" @loaded="toggleLoading" @row-click="showMacrotags">
              <template slot="microtags" slot-scope="props">
                <div>
                  <ul>
                    <li v-for="microtag in props.row.microtags.data">{{ microtag.microtag }}</li>
                  </ul>
                </div>
              </template>
              <template slot="actions" slot-scope="props">
                <div>
                  <button class="btn btn-danger btn-sm" v-on:click.stop="remove(props.row.id)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </template>
            </v-server-table>
          </div>
          <!-- /.box-body -->
          <div class="overlay" v-show="loading">
            <i class="fa fa-refresh fa-spin"></i>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import macrotagsApi from '../../api/macrotags'

  export default {
    data () {
      return {
        columns: [
          'macrotag', 'microtags', 'actions'
        ],
        options: {
          sortable: [
            'macrotag'
          ],
          requestFunction: function (query) {
            return macrotagsApi.index(query)
          }
        },
        loading: false
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Macrotags inseriti',
        createButton: {
          display: true,
          text: 'Nuovo macrotag',
          to: 'macrotag'
        }
      })
    },

    methods: {
      remove (id) {
        if (confirm('Sei sicuro di procedere?')) {
          this.loading = true
          macrotagsApi.delete(id)
            .then((response) => {
              this.$refs.macrotags.refresh()
              toastr.success('La macrotag è stata rimossa correttamente')
              this.loading = false
            })
            .catch((response) => {
              this.loading = false
            })
        }
      },
      toggleLoading () {
        // this.loading = !this.loading
      },
      showMacrotags (row) {
        this.$router.push({name: 'macrotagsShow', params: {id: row.row.id}})
      }
    }
  }
</script>

<style>
  tr {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/macrotags/Index.vue